<template>
    <div class='main hierarchy-page'>
        <div class='content'>
            <div class='content-header'>
                <h3>学校・行事の階層検索</h3>
                <p class='description'>学校名、学年名、行事名のいずれかを入力すると、ラボとカメラマンまでの階層を確認できます。</p>
            </div>

            <form class='search-form' @submit.prevent='search'>
                <div class='field has-addons'>
                    <div class='control is-expanded'>
                        <input
                            class='input'
                            type='search'
                            v-model='query'
                            maxlength='100'
                            placeholder='学校名・学年名・行事名'
                            aria-label='学校名、学年名、行事名で検索'
                        >
                    </div>
                    <div class='control'>
                        <button class='button is-info' type='submit' :disabled='loading || !trimmedQuery'>
                            {{ loading ? '検索中...' : '検索' }}
                        </button>
                    </div>
                </div>
            </form>

            <div v-if='errorMessage' class='notification is-danger'>
                {{ errorMessage }}
            </div>

            <div v-if='hasSearched && !loading && !results.length && !errorMessage' class='notification is-light'>
                該当する学校、学年、行事はありませんでした。
            </div>

            <div v-if='results.length' class='result-area'>
                <p class='result-count'>{{ results.length }}件</p>
                <div v-if='hasMore' class='notification is-warning'>
                    検索結果が多いため、先頭200件を表示しています。検索語を追加して絞り込んでください。
                </div>

                <div class='table-container'>
                    <table class='table is-striped is-hoverable is-fullwidth'>
                        <thead>
                            <tr>
                                <th>ラボ</th>
                                <th>カメラマン</th>
                                <th>学校</th>
                                <th>学年</th>
                                <th>行事</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for='result in results' :key='resultKey(result)'>
                                <td>
                                    <p class='entity-name'>{{ result.lab_name || '未設定' }}</p>
                                    <p v-if='result.lab_id' class='entity-meta'>ID: {{ result.lab_id }}</p>
                                    <p v-if='result.lab_email' class='entity-meta'>{{ result.lab_email }}</p>
                                </td>
                                <td>
                                    <p class='entity-name'>{{ result.photographer_name || '未設定' }}</p>
                                    <p v-if='result.photographer_id' class='entity-meta'>ID: {{ result.photographer_id }}</p>
                                    <p v-if='result.photographer_email' class='entity-meta'>{{ result.photographer_email }}</p>
                                </td>
                                <td>
                                    <p class='entity-name'>{{ result.school_name }}</p>
                                    <p class='entity-meta'>ID: {{ result.school_id }}</p>
                                </td>
                                <td>
                                    <p class='entity-name'>{{ result.year_name || '未登録' }}</p>
                                    <p v-if='result.year_id' class='entity-meta'>ID: {{ result.year_id }}</p>
                                </td>
                                <td>
                                    <p class='entity-name'>{{ result.event_name || '未登録' }}</p>
                                    <p v-if='result.event_id' class='entity-meta'>ID: {{ result.event_id }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AdminHierarchy',
    data () {
        return {
            query: '',
            results: [],
            hasMore: false,
            hasSearched: false,
            loading: false,
            errorMessage: ''
        }
    },
    computed: {
        trimmedQuery () {
            return this.query.trim()
        }
    },
    methods: {
        search () {
            if (!this.trimmedQuery || this.loading) return

            this.loading = true
            this.errorMessage = ''
            this.hasSearched = true

            this.axios.get(`${process.env.API_URL}/admin/hierarchy`, {
                params: {
                    query: this.trimmedQuery
                }
            }).then((res) => {
                this.results = res.data.results || []
                this.hasMore = !!res.data.hasMore
            }).catch(() => {
                this.results = []
                this.hasMore = false
                this.errorMessage = '検索中にエラーが発生しました。'
            }).finally(() => {
                this.loading = false
            })
        },
        resultKey (result) {
            return [
                result.lab_id || '',
                result.photographer_id || '',
                result.school_id || '',
                result.year_id || '',
                result.event_id || ''
            ].join('-')
        }
    }
}
</script>

<style scoped>

.hierarchy-page {
    width: calc(100vw - 200px);
    min-width: 0;
}

.content {
    width: 100%;
    max-width: 1400px;
    margin: auto;
    padding: 25px;
}

.content-header {
    margin-bottom: 24px;
}

.description {
    margin-top: 8px;
    color: #666;
}

.search-form {
    max-width: 760px;
    margin-bottom: 24px;
}

.result-area {
    margin-top: 20px;
}

.result-count {
    margin-bottom: 10px;
    font-weight: bold;
}

.table {
    min-width: 1050px;
}

.table th,
.table td {
    width: 20%;
    vertical-align: top;
}

.entity-name {
    font-weight: 600;
}

.entity-meta {
    margin-top: 3px;
    color: #777;
    font-size: 12px;
    word-break: break-all;
}

@media (max-width: 768px) {
    .hierarchy-page {
        width: calc(100vw - 60px);
    }

    .content {
        padding: 16px;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/admin/pages/Hierarchy.vue